import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

const ClockIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71z" />
        <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0" />
    </svg>
);

const formatTimeLabel = (date) => {
    if (!date) return 'Set time';
    return date.toLocaleString('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true,
    });
};

export default function ReminderDateTimePicker({
    customDate,
    setCustomDate,
    onDateOnlyChange,
    onSave,
    onToday,
    onClear,
    timeIntervals = 15,
}) {
    const [showTimePicker, setShowTimePicker] = useState(false);

    return (
        <div className={`reminder-dropdown__datepicker ${showTimePicker ? 'reminder-dropdown__datepicker--with-time' : ''}`}>
            <div className="reminder-dropdown__picker-row">
                <div className="reminder-dropdown__calendar-col">
                    <DatePicker
                        calendarClassName="reminder-dropdown__calendar reminder-dropdown__calendar--date"
                        wrapperClassName="reminder-dropdown__datepicker-wrapper"
                        selected={customDate}
                        onChange={onDateOnlyChange}
                        inline
                        minDate={new Date()}
                    />
                    {customDate && (
                        <button
                            type="button"
                            className={`reminder-dropdown__time-toggle ${showTimePicker ? 'reminder-dropdown__time-toggle--active' : ''}`}
                            onClick={() => setShowTimePicker((prev) => !prev)}
                            aria-expanded={showTimePicker}
                            title="Pick a time"
                        >
                            <ClockIcon />
                            <span>{formatTimeLabel(customDate)}</span>
                        </button>
                    )}
                </div>
                {showTimePicker && customDate && (
                    <div className="reminder-dropdown__time-col">
                        <span className="reminder-dropdown__time-col-label">Time</span>
                        <DatePicker
                            calendarClassName="reminder-dropdown__calendar reminder-dropdown__calendar--time"
                            wrapperClassName="reminder-dropdown__datepicker-wrapper"
                            selected={customDate}
                            onChange={(time) => setCustomDate(time)}
                            showTimeSelectOnly
                            showTimeSelect
                            timeIntervals={timeIntervals}
                            timeFormat="hh:mm aa"
                            dateFormat="h:mm aa"
                            inline
                        />
                    </div>
                )}
            </div>
            <div className="reminder-dropdown__datepicker-actions">
                <button type="button" className="reminder-dropdown__datepicker-link" onClick={onToday}>
                    Today
                </button>
                <button
                    type="button"
                    className="reminder-dropdown__datepicker-link reminder-dropdown__datepicker-link--muted"
                    onClick={() => {
                        setShowTimePicker(false);
                        onClear();
                    }}
                >
                    Clear
                </button>
                <button
                    type="button"
                    className="reminder-dropdown__datepicker-save"
                    onClick={() => {
                        if (customDate) {
                            onSave();
                        }
                    }}
                >
                    Save
                </button>
            </div>
        </div>
    );
}
